module.exports = __webpack_public_path__ + "img/OPTIONALSURFACEPATTERN.4febefbc.png";